export default __webpack_public_path__ + "static/lizMartin2-387ddc5a1e28fa17dd65e92dd254f8f4.svg";